import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "VIII. Vaccinations ワクチン接種", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5 text-darkgray-800" }, "Please list down vaccines you have received in the table below: 以下の表に、これまでに接種したワクチンを記入してください。", -1)
const _hoisted_4 = {
  key: 0,
  class: "col-span-full text-right"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-span-full lg:col-span-3" }
const _hoisted_7 = { class: "col-span-full lg:col-span-3" }
const _hoisted_8 = { class: "col-span-full lg:col-span-3" }
const _hoisted_9 = { class: "col-span-full lg:col-span-3" }

import TextInput from '@/components/inputs/TextInput.vue';
import CalendarPicker from '@/components/CalendarPicker.vue';
import { numberonly } from '@/helpers/NumberHelper';
import { ref } from 'vue';
import { onKeypressNumbersOnly, onPasteNumbersOnly } from '@/helpers/ValidationHelpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'VaccinationHistory',
  props: {
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: false
    },
    errors: {
        type: Array,
        required: true
    },
},
  setup(__props) {

const props = __props

const item = ref(props.form)

const addRow = () => {
    item.value.push({
        vaccine_type: null,
        brand_name: null,
        number_of_doses: null,
        date_received: null,
    })
}

const remove = (index: string) => {
    item.value.splice(index, 1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (vaccination, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-4 bg-primary-50 rounded-2xl p-5 lg:p-7 mb-2",
        key: index
      }, [
        (index >= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!__props.disableInputs)
                ? (_openBlock(), _createElementBlock("small", {
                    key: 0,
                    onClick: ($event: any) => (remove(index)),
                    class: "text-red-500 cursor-pointer text-sm"
                  }, "Remove", 8, _hoisted_5))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(TextInput, {
            modelValue: vaccination.vaccine_type,
            "onUpdate:modelValue": ($event: any) => ((vaccination.vaccine_type) = $event),
            id: `vaccine-type-${index}`,
            type: "text",
            placeholder: "Type of Vaccine ワクチンの種類",
            disabled: __props.disableInputs,
            error: __props.errors[`vaccinations_history.${index}.vaccine_type`] ? __props.errors[`vaccinations_history.${index}.vaccine_type`][0] : ''
          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "disabled", "error"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextInput, {
            modelValue: vaccination.brand_name,
            "onUpdate:modelValue": ($event: any) => ((vaccination.brand_name) = $event),
            id: `brand-name-${index}`,
            type: "text",
            placeholder: "Brand ブランド名",
            disabled: __props.disableInputs,
            error: __props.errors[`vaccinations_history.${index}.brand_name`] ? __props.errors[`vaccinations_history.${index}.brand_name`][0] : ''
          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "disabled", "error"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(TextInput, {
            modelValue: vaccination.number_of_doses,
            "onUpdate:modelValue": ($event: any) => ((vaccination.number_of_doses) = $event),
            id: `doses-${index}`,
            type: "text",
            placeholder: "Number of Doses 接種回数",
            disabled: __props.disableInputs,
            onKeypress: _unref(onKeypressNumbersOnly),
            onPaste: _unref(onPasteNumbersOnly),
            error: __props.errors[`vaccinations_history.${index}.number_of_doses`] ? __props.errors[`vaccinations_history.${index}.number_of_doses`][0] : ''
          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "disabled", "onKeypress", "onPaste", "error"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createBlock(CalendarPicker, {
            disabled: __props.disableInputs,
            key: vaccination.date_received,
            modelValue: vaccination.date_received,
            "onUpdate:modelValue": ($event: any) => ((vaccination.date_received) = $event),
            id: `date-received-${index}`,
            inline: false,
            placeholder: "Date Received 接種日",
            isTodayMaxDate: "",
            error: __props.errors[`vaccinations_history.${index}.date_received`] ? __props.errors[`vaccinations_history.${index}.date_received`][0] : ''
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "id", "error"]))
        ])
      ]))
    }), 128)),
    (!__props.disableInputs)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          onClick: addRow,
          class: "font-bold text-primary-500 hover:text-primary-700 transition cursor-pointer text-sm w-fit"
        }, " Add another + "))
      : _createCommentVNode("", true)
  ]))
}
}

})